import * as React from 'react';

import DeviceTrust32 from './DeviceTrust32';

export const deviceTrust32 = () => <DeviceTrust32 />;

export default {
    title: 'Icon/Content/DeviceTrust32',
    component: DeviceTrust32,
    parameters: {
        notes: "`import DeviceTrust32 from 'box-ui-elements/es/icon/content/DeviceTrust32';`",
    },
};
